import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import ActionApiWrapper from 'app/developer-v3/pages/actions/ActionApi/ActionApiWrapper';
import {
  currentActionClean,
  currentAuthFields,
  currentAuthType,
  currentLegacyAction,
  currentPlatformVariablesList,
  currentTestRequest,
  currentRequestTemplate,
  isCurrentAppDefinitionSaving,
  selectIsAuthSetupComplete,
  selectIsServiceSetup,
} from 'app/developer-v3/selectors';
import { SERVICE_TYPE } from 'app/developer-v3/constants';

import type { AppService, AppServiceLegacy } from 'app/developer-v3/types';

const mapStateToProps = state => {
  const actionLegacy = currentLegacyAction(state);
  return {
    action: currentActionClean(state),
    ...(actionLegacy ? { actionLegacy } : {}),
    authFields: currentAuthFields(state),
    authType: currentAuthType(state),
    getSuggestions: currentPlatformVariablesList(SERVICE_TYPE.actions, state),
    hasLoaded: CliAppDefinition.selectors.all.hasLoaded(state),
    isActionSetup: selectIsServiceSetup(state),
    isAuthSetupComplete: selectIsAuthSetupComplete(state),
    isLoading: CliAppDefinition.selectors.isLoading(state),
    isSaving: isCurrentAppDefinitionSaving(state),
    requestTemplate: currentRequestTemplate(state),
    testRequest: currentTestRequest(state),
  };
};

const mapDispatchToProps = dispatch => ({
  saveApiChanges(action: AppService, actionLegacy?: AppServiceLegacy) {
    dispatch(DeveloperActions.saveAction(action, actionLegacy));
  },

  setUnsavedChanges(hasUnsavedChanges: boolean) {
    dispatch(DeveloperActions.setUnsavedChanges(hasUnsavedChanges));
  },

  resetTestRequest() {
    dispatch(DeveloperActions.resetTestRequest());
  },

  resetTestLogs() {
    dispatch(DeveloperActions.resetTestLogs());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionApiWrapper);
